import React, { useEffect, useMemo, useState } from "react";
import "./App.css";

const owner = {
  name: "Jatinder",
  email: "jatinder112400@gmail.com",
  role: "Shopify Developer",
};

const pages = [
  {
    slug: "home",
    navLabel: "Home",
    heroTitle: "Shopify Development Built for Growth",
    heroText:
      "I am Jatinder, a Shopify developer handling customization, Liquid code, checkout work, and private/public apps for serious commerce brands.",
    stats: [
      { label: "Shopify Focus", value: "100%" },
      { label: "Delivery Style", value: "Fast + Clean" },
      { label: "Support", value: "Ongoing" },
    ],
    services: [
      "Theme customization and custom sections",
      "Advanced Liquid architecture",
      "Performance and conversion fixes",
      "Custom storefront feature builds",
    ],
    capabilities: [
      "Metafield-driven content models",
      "Reusable section systems",
      "Subscription and cart logic",
      "App integration setup",
    ],
    results: [
      "Stronger PDP and collection UX",
      "Faster load times and cleaner UX",
      "Higher trust with branded checkout",
      "Reduced manual operations",
    ],
    tools: [
      "Shopify Admin API",
      "Shopify Functions",
      "Hydrogen-ready architecture",
      "Version-controlled theme workflow",
    ],
    faq: [
      { q: "Do you work on existing stores?", a: "Yes, I handle both existing and new Shopify builds." },
      { q: "Can you support long-term work?", a: "Yes, I provide retained support and feature iteration." },
    ],
    ctaTitle: "Need Shopify work done end-to-end?",
    ctaText: "Send your store goals and I will map the right implementation plan.",
  },
  {
    slug: "customization",
    navLabel: "Customization",
    heroTitle: "Deep Theme Customization",
    heroText:
      "Custom sections, advanced templates, and UX upgrades tailored to your products and customer journey.",
    stats: [
      { label: "Theme Files", value: "Liquid + JSON" },
      { label: "Approach", value: "Reusable Blocks" },
      { label: "Device Coverage", value: "Desktop + Mobile" },
    ],
    services: [
      "Homepage and landing page rebuilds",
      "Collection and filter experience upgrades",
      "PDP conversion-focused layouts",
      "Cart and mini-cart custom behavior",
    ],
    capabilities: [
      "Schema and preset architecture",
      "Dynamic blocks with merchant controls",
      "Reusable snippets and utilities",
      "Clean CSS component strategy",
    ],
    results: [
      "Fewer theme limitations",
      "More control for merchants",
      "Better conversion paths",
      "Consistent brand UI language",
    ],
    tools: [
      "Shopify CLI",
      "Theme app extensions",
      "Git-based deployment flow",
      "Cross-device QA process",
    ],
    faq: [
      { q: "Can you match Figma exactly?", a: "Yes, pixel-level matching and responsive adaptation are standard." },
      { q: "Can you customize Dawn or premium themes?", a: "Yes, I work across free and paid Shopify themes." },
    ],
    ctaTitle: "Upgrade your storefront UX",
    ctaText: "Share your current theme and I will suggest a custom roadmap.",
  },
  {
    slug: "liquid-code",
    navLabel: "Liquid Code",
    heroTitle: "Advanced Liquid Engineering",
    heroText:
      "Robust Liquid code structure for maintainable templates, dynamic content, and scalable storefront logic.",
    stats: [
      { label: "Logic", value: "Maintainable" },
      { label: "Patterns", value: "Component-First" },
      { label: "Code Quality", value: "Production Ready" },
    ],
    services: [
      "Template logic refactors",
      "Collection and variant-driven rendering",
      "Metafield and metaobject output",
      "Localization-ready Liquid patterns",
    ],
    capabilities: [
      "Conditional storefront rendering",
      "Smart snippet abstraction",
      "Fallback-safe data handling",
      "Section architecture cleanup",
    ],
    results: [
      "Cleaner codebase",
      "Faster feature updates",
      "Lower technical debt",
      "Reliable data-driven components",
    ],
    tools: [
      "Liquid language",
      "JSON templates",
      "Metafields and metaobjects",
      "Theme performance profiling",
    ],
    faq: [
      { q: "Do you optimize old Liquid files?", a: "Yes, I modernize and simplify legacy theme logic." },
      { q: "Can you build reusable snippets?", a: "Yes, reusable snippet systems are core to my workflow." },
    ],
    ctaTitle: "Need clean and scalable Liquid code?",
    ctaText: "I can audit and rebuild your theme logic quickly.",
  },
  {
    slug: "checkout-work",
    navLabel: "Checkout Work",
    heroTitle: "Checkout Experience and Logic",
    heroText:
      "Checkout customization focused on trust, speed, and conversion with Shopify-native capabilities.",
    stats: [
      { label: "Goal", value: "Higher Conversion" },
      { label: "Focus", value: "Trust + Speed" },
      { label: "Model", value: "Data-Informed" },
    ],
    services: [
      "Checkout UI refinements",
      "Post-purchase flow customization",
      "Validation and rule logic setup",
      "Checkout extensibility implementation",
    ],
    capabilities: [
      "Checkout branding alignment",
      "Offer and upsell placements",
      "Address and shipping logic",
      "Payment-step clarity improvements",
    ],
    results: [
      "Less checkout drop-off",
      "Clearer order summary UX",
      "Improved order value opportunities",
      "Better confidence at payment stage",
    ],
    tools: [
      "Checkout UI extensions",
      "Shopify Functions",
      "Flow automation hooks",
      "Event-based analytics",
    ],
    faq: [
      { q: "Do you handle Shopify Plus checkout?", a: "Yes, including advanced checkout extensibility work." },
      { q: "Can you set logic for shipping/payment rules?", a: "Yes, custom rule-based behavior is supported." },
    ],
    ctaTitle: "Improve your checkout conversion",
    ctaText: "I can review your funnel and implement practical checkout wins.",
  },
  {
    slug: "private-apps",
    navLabel: "Private Apps",
    heroTitle: "Custom Private Shopify Apps",
    heroText:
      "Private app development for store-specific workflows, backend operations, and custom automation.",
    stats: [
      { label: "App Type", value: "Private" },
      { label: "Use Case", value: "Store-Specific" },
      { label: "Security", value: "Controlled Access" },
    ],
    services: [
      "Custom admin dashboards",
      "Inventory and order automation",
      "ERP/CRM integrations",
      "Webhook-driven operations",
    ],
    capabilities: [
      "Custom API integrations",
      "Task scheduling and sync logic",
      "Data pipeline handling",
      "Role-based access patterns",
    ],
    results: [
      "Reduced manual work",
      "Reliable operational workflows",
      "Fewer back-office errors",
      "Faster internal execution",
    ],
    tools: [
      "Node.js backend services",
      "Shopify Admin GraphQL API",
      "Webhook architecture",
      "Cloud deployment pipelines",
    ],
    faq: [
      { q: "Can a private app run store automation daily?", a: "Yes, scheduled and event-driven workflows are common." },
      { q: "Do you integrate third-party systems?", a: "Yes, private apps are ideal for custom integrations." },
    ],
    ctaTitle: "Build the private app your store needs",
    ctaText: "Share your operations pain points and I will design the right app flow.",
  },
  {
    slug: "public-apps",
    navLabel: "Public Apps",
    heroTitle: "Public App Development",
    heroText:
      "Public Shopify app development from architecture to listing readiness, billing, and merchant onboarding.",
    stats: [
      { label: "Distribution", value: "Shopify Ecosystem" },
      { label: "Stack", value: "Scalable" },
      { label: "Focus", value: "Merchant UX" },
    ],
    services: [
      "App concept and architecture",
      "Merchant onboarding flow",
      "Billing model implementation",
      "Embedded admin app UX",
    ],
    capabilities: [
      "OAuth and install flow",
      "App block and extension setup",
      "Plan and feature gating",
      "Admin dashboard modules",
    ],
    results: [
      "Clean install-to-value journey",
      "Scalable feature rollout",
      "Stronger merchant retention",
      "Platform-compliant build",
    ],
    tools: [
      "Shopify App Bridge",
      "Polaris-aligned components",
      "Webhook + background workers",
      "Billing API integration",
    ],
    faq: [
      { q: "Can you prepare app store submission?", a: "Yes, I handle readiness and technical compliance requirements." },
      { q: "Do you support public app maintenance?", a: "Yes, including iterative releases and support updates." },
    ],
    ctaTitle: "Launch your Shopify public app",
    ctaText: "I can take your app from idea to reliable production release.",
  },
  {
    slug: "contact",
    navLabel: "Contact",
    heroTitle: "Work With Jatinder",
    heroText:
      "If you need Shopify customization, Liquid work, checkout updates, or apps, contact me directly.",
    stats: [
      { label: "Primary Email", value: owner.email },
      { label: "Specialization", value: "Shopify" },
      { label: "Engagement", value: "Project or Ongoing" },
    ],
    services: [
      "Discovery call and requirement mapping",
      "Technical planning and scope definition",
      "Feature implementation and QA",
      "Post-launch optimization",
    ],
    capabilities: [
      "Quick turnaround execution",
      "Clear communication and updates",
      "Priority bug-fix support",
      "Long-term growth support",
    ],
    results: [
      "Predictable delivery process",
      "Transparent scope and milestones",
      "Strong technical documentation",
      "Reliable release quality",
    ],
    tools: [
      "Email-first communication",
      "Structured milestone planning",
      "Version-based rollout",
      "QA checklist and reporting",
    ],
    faq: [
      { q: "How can I start a project?", a: `Email ${owner.email} with your store URL and goals.` },
      { q: "Do you work with agencies as well?", a: "Yes, I collaborate with agencies and direct brands." },
    ],
    ctaTitle: "Start your Shopify project",
    ctaText: `Email ${owner.email} and I will reply with next steps.`,
  },
];

const slugMap = Object.fromEntries(pages.map((page) => [page.slug, page]));

function getHashSlug() {
  const hash = window.location.hash.replace("#/", "").trim();
  return slugMap[hash] ? hash : "home";
}

function App() {
  const [slug, setSlug] = useState(getHashSlug);

  useEffect(() => {
    const onHashChange = () => setSlug(getHashSlug());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => {
    const isJSDOM = /jsdom/i.test(window.navigator.userAgent || "");
    if (!isJSDOM && typeof window.scrollTo === "function") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    const nodes = Array.from(document.querySelectorAll(".reveal"));
    if (typeof IntersectionObserver !== "function") {
      nodes.forEach((node) => node.classList.add("is-visible"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, [slug]);

  const page = useMemo(() => slugMap[slug], [slug]);

  return (
    <div className="site-shell">
      <div className="motion-orb orb-a" aria-hidden="true" />
      <div className="motion-orb orb-b" aria-hidden="true" />
      <header className="topbar">
        <div className="brand">{owner.name} | Shopify Developer</div>
        <nav className="main-nav" aria-label="Main navigation">
          {pages.map((item) => (
            <a
              key={item.slug}
              href={`#/${item.slug}`}
              className={item.slug === slug ? "active" : ""}
            >
              {item.navLabel}
            </a>
          ))}
        </nav>
      </header>

      <main key={slug} className="page-stage">
        <section className="section hero reveal">
          <div className="badge">{owner.role}</div>
          <h1>{page.heroTitle}</h1>
          <p>{page.heroText}</p>
          <a className="cta-btn" href={`mailto:${owner.email}`}>
            Email {owner.name}
          </a>
        </section>

        <section className="section stats reveal">
          {page.stats.map((item, index) => (
            <article key={item.label} className="stat-card reveal" style={{ "--stagger": `${index * 90}ms` }}>
              <h3>{item.value}</h3>
              <p>{item.label}</p>
            </article>
          ))}
        </section>

        <section className="section reveal">
          <SectionHeading
            title="Services"
            text="Core Shopify services delivered for speed, quality, and measurable results."
          />
          <div className="grid four-col">
            {page.services.map((item, index) => (
              <Card
                key={item}
                delay={index}
                title={item}
                text="Execution focused on clean implementation and merchant usability."
              />
            ))}
          </div>
        </section>

        <section className="section alt-bg reveal">
          <SectionHeading
            title="Capabilities"
            text="Technical capabilities designed for modern Shopify store requirements."
          />
          <div className="grid four-col">
            {page.capabilities.map((item, index) => (
              <Card
                key={item}
                delay={index}
                title={item}
                text="Built with maintainability and future enhancements in mind."
              />
            ))}
          </div>
        </section>

        <section className="section reveal">
          <SectionHeading
            title="Outcomes"
            text="Practical outcomes achieved through focused Shopify implementation."
          />
          <div className="grid four-col">
            {page.results.map((item, index) => (
              <Card
                key={item}
                delay={index}
                title={item}
                text="Aligned to conversion, operations, and long-term store growth."
              />
            ))}
          </div>
        </section>

        <section className="section alt-bg reveal">
          <SectionHeading
            title="Tech Stack"
            text="Tools and technologies selected based on use case and scale."
          />
          <div className="stack-list">
            {page.tools.map((tool, index) => (
              <span key={tool} className="reveal" style={{ "--stagger": `${index * 80}ms` }}>
                {tool}
              </span>
            ))}
          </div>
        </section>

        <section className="section reveal">
          <SectionHeading
            title="FAQs"
            text="Common project questions from Shopify brands and teams."
          />
          <div className="faq-wrap">
            {page.faq.map((item, index) => (
              <article key={item.q} className="faq-item reveal" style={{ "--stagger": `${index * 120}ms` }}>
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section cta reveal">
          <h2>{page.ctaTitle}</h2>
          <p>{page.ctaText}</p>
          <a className="cta-btn" href={`mailto:${owner.email}`}>
            {owner.email}
          </a>
        </section>
      </main>

      <footer className="footer reveal">
        <p>
          {owner.name} | Shopify Customization, Liquid Code, Checkout Work, Private/Public Apps
        </p>
      </footer>
    </div>
  );
}

function SectionHeading({ title, text }) {
  return (
    <div className="section-heading reveal">
      <h2>{title}</h2>
      <p>{text}</p>
    </div>
  );
}

function Card({ title, text, delay }) {
  return (
    <article className="feature-card reveal" style={{ "--stagger": `${delay * 85}ms` }}>
      <h3>{title}</h3>
      <p>{text}</p>
    </article>
  );
}

export default App;
